import "./App.css";
import Banner from "./components/banner";
import Footer from "./components/footer";
import Gallery from "./components/image-gallery";
import HeartFeltMessage from "./components/message_button";
import SecretMessage from "./components/secretMessage";
import Timeline from "./components/timeline";
import Video from "./components/video";
import { useState } from "react";
import Swal from "sweetalert2";
import { loginPassword } from "./utils/constants";

function App() {
  const [password, setPassword] = useState("");
  const [showEnterPass, setEnterPass] = useState(true);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [error, setError] = useState("");


  const handleUnlock = () => {
    if (password === loginPassword) {
      setIsUnlocked(true);
      setEnterPass(false);
      setError("");
    } else {
      setIsUnlocked(false);
      setError("Oops! Wrong password. Try again.");
    }
  };

  return (
    <div>
      {showEnterPass && (
        <div className="mainPass">
          <div style={{ zIndex: 2 }} className="mainPass-div">
            <h2>
              Only for you!. <br /> Unlock it! 💌
            </h2>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-4 px-4 py-2 border rounded-lg w-full text-center"
              placeholder="Enter secret password"
            />
            <button onClick={handleUnlock} className="mt-4 bg-pink-500 text-white px-6 py-2 rounded-lg shadow hover:bg-pink-600 transition">
              Unlock
            </button>
            {error &&
              Swal.fire({
                title: "Try again : )",
                text: "Oops!! the password is wrong!!",
                icon: "question",
              }).then(() => {
                setError("");
              })}
          </div>

          <div className="set" style={{ zIndex: 2 }}>
            <div>
              <img src="leaves1.png" alt="imag" />
            </div>
            <div>
              <img src="leaves2.png" alt="imag" />
            </div>
            <div>
              <img src="leaves3.png" alt="imag" />
            </div>
            <div>
              <img src="leaves4.png" alt="imag" />
            </div>
            <div>
              <img src="leaves1.png" alt="imag" />
            </div>
            <div>
              <img src="leaves2.png" alt="imag" />
            </div>
            <div>
              <img src="leaves3.png" alt="imag" />
            </div>
            <div>
              <img src="leaves4.png" alt="imag" />
            </div>
          </div>
          <div className="set set2" style={{ zIndex: 4 }}>
            <div>
              <img src="leaves1.png" alt="imag" />
            </div>
            <div>
              <img src="leaves2.png" alt="imag" />
            </div>
            <div>
              <img src="leaves3.png" alt="imag" />
            </div>
            <div>
              <img src="leaves4.png" alt="imag" />
            </div>
            <div>
              <img src="leaves1.png" alt="imag" />
            </div>
            <div>
              <img src="leaves2.png" alt="imag" />
            </div>
            <div>
              <img src="leaves3.png" alt="imag" />
            </div>
            <div>
              <img src="leaves4.png" alt="imag" />
            </div>
          </div>
          <div className="set set3" style={{ zIndex: 1 }}>
            <div>
              <img src="leaves1.png" alt="imag" />
            </div>
            <div>
              <img src="leaves2.png" alt="imag" />
            </div>
            <div>
              <img src="leaves3.png" alt="imag" />
            </div>
            <div>
              <img src="leaves4.png" alt="imag" />
            </div>
            <div>
              <img src="leaves1.png" alt="imag" />
            </div>
            <div>
              <img src="leaves2.png" alt="imag" />
            </div>
            <div>
              <img src="leaves3.png" alt="imag" />
            </div>
            <div>
              <img src="leaves4.png" alt="imag" />
            </div>
          </div>
        </div>
      )}
      {isUnlocked && (
        <div className="snowFall">
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <div className="snowFlakes"></div>
          <Banner />
          <HeartFeltMessage />
          <Video />
          <Timeline />
          <Gallery />
          <SecretMessage />
          <Footer />{" "}
        </div>
      )}
    </div>
  );
}

export default App;
